import { Grid, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import { useState } from 'react';

// Our Components
import Alert from 'components/Alert';
import SearchClients from 'components/FADashboard/SearchClients';
import RefreshButton from 'components/Button/RefreshButton';
import RefreshClientDataModal from 'components/FeatureFlag/RefreshClientDataModal';

// Our Hooks
import { useIsFeatureFlagCompany } from 'shared/utils/featureflags/isFeatureFlagCompany';
import useMutateRefreshAllClientData from 'hooks/dataRefresh/useMutateRefreshAllClientData';
import useGetProfile from 'hooks/useGetProfile';

function TableHeadingAndSearch({
	disable,
	tableHeading,
	deBounceCallBack,
	isPaginationLoading
}) {
	const SoraTheme = useTheme();
	const [isModalOpen, setIsModalOpen] = useState(false);

	const refreshAllClientData = useMutateRefreshAllClientData();

	const { data: profileData } = useGetProfile();

	const { companyId } = profileData || {};

	const isFeatureFlagCompany = useIsFeatureFlagCompany(companyId);

	const { isLoading, isSuccess, isError } = refreshAllClientData;

	return (
		<>
			{isSuccess && <Alert variant="success" />}
			{isError && <Alert variant="error" />}

			<Grid
				container
				item
				xs={12}
				sx={{
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: 4
				}}
			>
				<Grid
					item
					xs={12}
					sm={6}
					sx={{
						display: 'flex',
						gap: 2,
						alignItems: 'center'
					}}
				>
					<Typography
						variant="h2Gascogne"
						component="h2"
						sx={{
							color: SoraTheme.palette.primary.indigo
						}}
					>
						{tableHeading}
					</Typography>
					<RefreshButton
						disable={disable}
						isLoading={isLoading}
						handleOnClick={() => {
							if (isFeatureFlagCompany) {
								setIsModalOpen(true);
							} else {
								refreshAllClientData.mutate();
							}
						}}
					/>

					{/* Feature flag modal for Todd */}
					<RefreshClientDataModal
						isModalOpen={isModalOpen}
						setIsModalOpen={setIsModalOpen}
						refreshCallBack={() => refreshAllClientData.mutate()}
						isLoading={isLoading}
					/>
				</Grid>

				<Grid item xs={12} sm={4} xl={3} sx={{ marginRight: 4 }}>
					<SearchClients
						debounceCallBack={deBounceCallBack}
						disable={isPaginationLoading}
					/>
				</Grid>
			</Grid>
		</>
	);
}

TableHeadingAndSearch.propTypes = {
	tableHeading: PropTypes.string.isRequired
};

export default TableHeadingAndSearch;
